

import { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import './style.scss';
import Style from './Style';
import VideoLayout from './VideoLayout';
import { getVideos } from './utils/functions';
import { preloader } from './utils/icons';


// Youtube Video gallery
document.addEventListener('DOMContentLoaded', () => {
	const allBlockDirectory = document.querySelectorAll('.wp-block-ytvgb-gallery');
	allBlockDirectory.forEach(directory => {
		const attributes = JSON.parse(directory.dataset.attributes);
		const dataInfo = JSON.parse(directory?.dataset?.ytvgbinfo);
		const { key } = dataInfo;

		createRoot(directory).render(<>
			<Style attributes={attributes} clientId={attributes.cId} />
			<RenderVideos attributes={attributes} apiKey={key} />
		</>);
		directory?.removeAttribute('data-attributes');
	});
});


const RenderVideos = ({ attributes, apiKey }) => {

	const { configure } = attributes;
	const { id } = configure;
	const [loading, setLoading] = useState(true);
	const [nextPageToken, setNextPageToken] = useState(null);
	const [videos, setVideos] = useState([]);
	const [error, setError] = useState(null);

	const callVideos = () => getVideos(apiKey, attributes, setLoading, nextPageToken, setNextPageToken, setVideos, videos, setError);

	useEffect(() => {
		if (apiKey && id) {
			callVideos();
		}
	}, [apiKey]);

	return <RenderContent videos={videos} attributes={attributes} loading={loading} callVideos={callVideos} nextPageToken={nextPageToken} />
}


export const RenderContent = ({ videos, attributes, loading, callVideos, nextPageToken }) => {

	return <div className="ytvgbYouTubeVideoGallery">
		<VideoLayout attributes={attributes} isLoading={loading} videos={videos} callVideos={callVideos} nextPageToken={nextPageToken} preloader={preloader} />
	</div>
}